// extracted by mini-css-extract-plugin
export default {"th":"TableSort_th__r6GkS","control":"TableSort_control__O-Qtw","icon":"TableSort_icon__uO3RR"};